// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enroll-mfa-scene .radio-buttons .radio .radio-item:first-child {
  margin-right: 2rem;
}
.enroll-mfa-scene .after-mfa-confirmed {
  min-height: 84vh;
  max-width: 35rem;
  margin: 0 auto;
  padding: 9.6rem 0 3.2rem;
}
.enroll-mfa-scene .after-mfa-confirmed h3 {
  margin-bottom: 1.2rem;
}
.enroll-mfa-scene .after-mfa-confirmed p {
  margin-bottom: 2.4rem;
}
.enroll-mfa-scene .confirm-phone-mfa {
  min-height: 63vh;
  max-width: 35rem;
  margin: 0 auto;
  padding: 9.6rem 0 3.2rem;
}
.enroll-mfa-scene .confirm-phone-mfa h3 {
  margin-bottom: 2.4rem;
}
.enroll-mfa-scene .confirm-phone-mfa p .disclaimer {
  font-size: 1.2rem;
}
.enroll-mfa-scene .confirm-phone-mfa p {
  font-size: 1.4rem;
  line-height: 2.2rem;
  margin-bottom: 2.4rem;
}
.enroll-mfa-scene .confirm-phone-mfa a {
  font-size: 1.4rem;
  line-height: 2.2rem;
  font-weight: 700;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/EnrollMFAScene/index.scss"],"names":[],"mappings":"AAIQ;EACE,kBAAA;AAHV;AASE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;AAPJ;AASI;EACE,qBAAA;AAPN;AAUI;EACE,qBAAA;AARN;AAYE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;AAVJ;AAYI;EACE,qBAAA;AAVN;AAcM;EACE,iBAAA;AAZR;AAUI;EAKE,iBAAA;EACA,mBAAA;EACA,qBAAA;AAZN;AAeI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;AAbN","sourcesContent":[".enroll-mfa-scene {\n  .radio-buttons {\n    .radio {\n      .radio-item {\n        &:first-child {\n          margin-right: 2rem;\n        }\n      }\n    }\n  }\n\n  .after-mfa-confirmed {\n    min-height: 84vh;\n    max-width: 35rem;\n    margin: 0 auto;\n    padding: 9.6rem 0 3.2rem;\n\n    h3 {\n      margin-bottom: 1.2rem;\n    }\n\n    p {\n      margin-bottom: 2.4rem;\n    }\n  }\n\n  .confirm-phone-mfa {\n    min-height: 63vh;\n    max-width: 35rem;\n    margin: 0 auto;\n    padding: 9.6rem 0 3.2rem;\n\n    h3 {\n      margin-bottom: 2.4rem;\n    }\n\n    p {\n      .disclaimer {\n        font-size: 1.2rem;\n      }\n\n      font-size: 1.4rem;\n      line-height: 2.2rem;\n      margin-bottom: 2.4rem;\n    }\n\n    a {\n      font-size: 1.4rem;\n      line-height: 2.2rem;\n      font-weight: 700;\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
